import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    {
      /* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */
    }

    emailjs
      .sendForm(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        e.target,
        "YOUR_PUBLIC_KEY"
      )
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          {/* Información principal */}
          <div className="col-md-6">
            <div className="contact-section">
              <h3>Información de contacto</h3>
              <p>
                <i className="fa fa-map-marker"></i> Dirección: Tienda de
                Regalos y Productos Naturales, Barrio Industrial
              </p>
              <p>
                <i className="fa fa-phone"></i> Celular: 0961 383 306 / 0986 910
                708
              </p>
              <p>
                <i className="fa fa-envelope-o"></i> Email:
                jcesarsaucedo1993@gmail.com
              </p>
            </div>

            <div className="contact-section">
              <h3>Horarios disponibles:</h3>
              <p>Mañana de 8 a 15 horas</p>
              <p>Noche de 18 a 00 horas</p>
              <p>De viernes a domingo.</p>
            </div>
            
          </div>

          {/* Contactos opcionales */}
          <div className="col-md-6">
            <div className="contact-section">
              <h3>Contactos adicionales</h3>
              <ul>
                <li>Asadero Cabita – 0974 379 252</li>
                <li>Asadero Raúl Gavilan – 0991 519 658</li>
                <li>Moza Gissel Giménez – 0991 891 966</li>
                <li>Alquiler de cubiertos Leticia Ferreira – 0981 242 569</li>
                <li>Decoradora Ña Marta – 0981 371 325</li>
              </ul>
            </div>
            <div className="contact-section">
              <h3>Pago y reservas</h3>
              <p>
                <strong>Pago:</strong> Transferencia bancaria o giros Tigo
              </p>
              <p>
                <strong>Reserva:</strong> La reserva se hace con el pago
                anticipado de 250.000 Gs.
              </p>
            </div>
          </div>

          {/* Redes sociales */}
          <div className="col-md-12">
            <div className="social text-center">
              <h3>Síguenos en redes</h3>
              <ul className="social-icons">
                <li>
                  <a href="https://www.facebook.com/naturalesregaloscaacupe">
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/naturalesregaloscaacupe/">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@ingjuliosg">
                    <i className="fa fa-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Tienda de Regalos y Productos Naturales
            {/* <a href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a> */}
          </p>
        </div>
      </div>
    </div>
  );
};
